import { useParams, useNavigate } from 'react-router-dom';
import { Card, Typography, Tag, Space, Divider, Button, message, Modal } from 'antd';
import ReactMarkdown from 'react-markdown';
import { EditOutlined, DeleteOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import './index.css';

const { Title, Text, Paragraph } = Typography;

const PostDetail = ({ posts, loggedInUser, onDeletePost }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const postId = Number(id);
  const post = posts.find(item => item?.id === postId) || null;

  // 文章不存在的提示
  if (!post) {
    return (
      <div className="post-not-found">
        <Card>
          <Title level={3}>文章不存在或已被删除</Title>
          <Text type="secondary">
            <Button 
              type="text" 
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/')}
              style={{ marginRight: 8 }}
            >
              返回首页
            </Button>
            查看其他文章~
          </Text>
        </Card>
      </div>
    );
  }

  // 判断是否为文章作者（权限控制）
  const isAuthor = post.author === loggedInUser?.username;

  // 编辑文章：跳转到WritePost编辑页
  const handleEdit = () => {
    navigate(`/write?edit=${postId}`);
  };

  // 删除文章：调用父组件的删除方法（不再直接操作localStorage）
  const handleDelete = () => {
    Modal.confirm({
      title: '确定要删除这篇文章吗？',
      content: '删除后无法恢复，请谨慎操作',
      okText: '确认删除',
      cancelText: '取消',
      okType: 'danger',
      onOk: () => {
        try {
          onDeletePost(postId); // 调用App.js的删除方法
          message.success('文章删除成功！');
          navigate('/');
        } catch (err) {
          message.error('删除失败，请重试');
        }
      }
    });
  };

  return (
    <div className="post-detail-page">
      <Card className="post-detail-card">
        {/* 操作按钮区（仅作者可见） */}
        {isAuthor && (
          <Space className="post-actions" style={{ marginBottom: 16 }}>
            <Button type="primary" icon={<EditOutlined />} onClick={handleEdit}>
              编辑文章
            </Button>
            <Button danger icon={<DeleteOutlined />} onClick={handleDelete}>
              删除文章
            </Button>
          </Space>
        )}

        {/* 文章标题 */}
        <Title level={2} className="post-title">{post.title}</Title>
        
        {/* 文章元信息（作者、时间、分类、标签） */}
        <Space className="post-meta" wrap>
          <Text type="secondary">作者：{post.author}</Text>
          <Text type="secondary">发布时间：{post.createTime}</Text>
          {post.category && (
            <Text type="secondary">分类：{post.category}</Text>
          )}
          <Space size="small">
            {Array.isArray(post.tags) && post.tags.map(tag => (
              <Tag key={tag} color="blue">{tag}</Tag>
            ))}
          </Space>
        </Space>
        
        <Divider />
        
        {/* 文章摘要 */}
        <div className="post-summary">
          <Text strong>摘要：</Text>
          <Paragraph>{post.summary || '无摘要'}</Paragraph>
        </div>
        
        <Divider />
        
        {/* 文章内容（Markdown渲染） */}
        <div className="post-content">
          <ReactMarkdown>{post.content || '无内容'}</ReactMarkdown>
        </div>
      </Card>
    </div>
  );
};

export default PostDetail;